import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap'
import { toast } from 'react-toastify';
import axios from 'api/axios';
import moment from 'moment/moment';

import PageHeader from 'components/common/PageHeader';
import DataCard from 'components/mycomponents/DataCard';
import ModalAlert from 'components/mycomponents/ModalAlert';

import Config from 'utils/config';

import Data from './Data';
import Detail from './Detail';

const BusReport = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [dataDetail, setDataDetail] = useState(null);
    const [busSelected, setBusSelected] = useState('');
    const [showDetail, setShowDetail] = useState(false);
    const [keyword, setKeyword] = useState({q:'', reportTime:1, reportMonth: moment().format('D'), reportYear: moment().format('YYYY'), fromDate: moment().format('YYYY-MM-DD'), toDate: moment().format('YYYY-MM-DD')});
    const [keywordShow] = useState({q: true, reportTime: false, reportMonth: false, reportYear: false, fromDate: true, toDate: false});
    const [pagination, setPagination] = useState({disabledPrev: true, disabledNext: false, pageTotal: 0, currentPage: 1, limit: 10, numberStart: 0});
    const [loadingData, setLoadingData] = useState(false);
    const [loadingDataDetail, setLoadingDataDetail] = useState(false);
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});

    // Declare Constant Variable
    const navigate = useNavigate();
    const DATA_URL = '/report/driver';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };

    // function get data
    const getData = async (page = 1, limit = 10) => {
        setLoadingData(true);
        try {
            const response = await axios.get(`${DATA_URL}?q=${keyword.q}&from=${keyword.fromDate}&to=${keyword.toDate}&page=${page}&limit=${limit}`, HEADER_AUTHORIZATION);
            const responseResult = response?.data;
            const responseData = responseResult?.data;
            const responseDataLength = responseResult?.length;
            const responseDataPageTotal = responseResult?.page_total;

            if (responseDataLength > 0) {
                setData(responseData);
                setPagination(prevState => {
                    return {...prevState, pageTotal: responseDataPageTotal, limit: limit, currentPage: page, numberStart: limit * (page - 1)}
                })
            } else {
                setData(null);
            }
            if (page >= responseDataPageTotal) {
                setPagination(prevState => {
                    return {...prevState, disabledNext: true}
                })
            } else {
                setPagination(prevState => {
                    return {...prevState, disabledNext: false}
                })
            }
            if (page === 1) {
                setPagination(prevState => {
                    return {...prevState, disabledPrev: true}
                })
            }
            setLoadingData(false);
            
        } catch (err) {
            setLoadingData(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    // Get Data On Load
    useEffect(() => {
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');

        const keywordValue = keywordParam ? keywordParam : '';
        const fromDateValue = fromDateParam ? fromDateParam : moment().format('YYYY-MM-DD');
        const toDateValue = toDateParam ? toDateParam : moment().format('YYYY-MM-DD');

        let keywordTemp = keyword;
        keywordTemp.q = keywordValue
        keywordTemp.fromDate = fromDateValue
        keywordTemp.toDate = toDateValue
        setKeyword(keywordTemp);
        // setKeyword(prevState => {
        //     return {...prevState, q: keywordValue, fromDateq: fromDateValue, toDate: toDateValue};
        // })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    // Toggle Form to open and close modal detail
    const handleToggleDetail = () => {
        setShowDetail(!showDetail);
    }

    const handleDetail = async (intid) => {
        const selectData = data ? data.find(data => parseFloat(data.intid) === parseFloat(intid)) : null;
        const busName = selectData ? selectData.vcnama : '';
        setBusSelected(busName);

        setLoadingDataDetail(true);
        try {
            const response = await axios.get(`${DATA_URL}/detail/${intid}/${keyword.fromDate}`, HEADER_AUTHORIZATION);
            const responseData = response?.data;
            const responseDataResult = responseData?.data;
            
            setDataDetail(responseDataResult)
            setShowDetail(true);
            setLoadingDataDetail(false);
        } catch (err) {
            setLoadingDataDetail(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleChangeForm = (event) => {
        const {value, name} = event.target;
        if (name === 'q') {
            setKeyword(prevState => {
                return {...prevState, [name]: value};
            })
        } else if (name === 'limit') {
            setPagination(prevState => {
                return {...prevState, limit: value}
            })
            const page = 1;
            const keywordSearch = keyword;
            const pathUrl = window.location.pathname;
            const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
            navigate(urlNavigate)
            getData(1, value)
        }
    }

    const handleChangeDate = (value, name) => {
        setKeyword(prevState => {
            return {...prevState, [name]: moment(value).format('YYYY-MM-DD')};
        })
    }

    const handleSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const page = 1;
        const keywordSearch = keyword.q;
        const keywordFromDate = moment(keyword.fromDate).format('YYYY-MM-DD');
        const keywordToDate = moment(keyword.toDate).format('YYYY-MM-DD');
        const pathUrl = window.location.pathname;
        const urlNavigate = `${pathUrl}?q=${keywordSearch}&from=${keywordFromDate}&to=${keywordToDate}&page=${page}`
        navigate(urlNavigate)
        getData(page)
    }

    const handleClickPagination = (type) => {
        let count = 0;
        if (type === 'prev') {
            count = -1
        }
        if (type === 'next') {
            count = 1
        }

        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const pageParam = urlParams.get('page');
        const page = pageParam ? parseFloat(pageParam) + count : 2;
        const keywordSearch = keywordParam ? keywordParam : keyword;
        const pathUrl = window.location.pathname;

        if (page > 1) {
            setPagination(prevState => {
                return {...prevState, disabledPrev: false}
            })
        } else {
            setPagination(prevState => {
                return {...prevState, disabledPrev: true}
            })
        }

        const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
        navigate(urlNavigate)
        getData(page, pagination.limit)
    }

    const handleConfirmAlert = () => {
        setShowAlert(prevState => { return {...prevState, show: false}});
    }

    const handleClickExport = () => {
        window.open(Config.baseUrlApi + '/report/driver/export/' + keyword.fromDate, '_blank')
    }
    
    return (
        <>
            {/* Page Header */}
            <PageHeader
                title="Laporan Sopir"
                description=""
                className="mb-3"
            >
            </PageHeader>

            {/* Data */}
            <DataCard>
                <DataCard.HeaderReport title={''} keywordShow={keywordShow} keyword={keyword} handleChangeKeyword={handleChangeForm} handleSearch={handleSearch} handleChangeDate={handleChangeDate}  exportExcel handleClickExport={handleClickExport} />
                <DataCard.Body>
                    <Data 
                        dataMain={data} 
                        actionDetail={handleDetail} 
                        numberStart={pagination.numberStart} 
                        isLoading = {loadingData}
                    />
                    <Row>
                        <Col sm={2}>
                            <Form.Select
                                name="limit"
                                value={pagination.limit}
                                onChange={handleChangeForm}
                            >
                                <option value={10}>10 Baris</option>
                                <option value={20}>20 Baris</option>
                                <option value={30}>30 Baris</option>
                            </Form.Select>
                        </Col>
                        <Col sm={10}>
                            <div className="float-end">
                                <Button variant="primary" size="sm" disabled={pagination.disabledPrev} onClick={() => handleClickPagination('prev')} className="me-2">Sebelumnya</Button>
                                <Button variant="primary" size="sm" disabled={pagination.disabledNext} onClick={() => handleClickPagination('next')}>Selanjutnya</Button>
                            </div>
                        </Col>
                    </Row>
                </DataCard.Body>
            </DataCard>

            {/* Detail Data */}
            <Detail 
                show={showDetail}
                handleClose={handleToggleDetail}
                data={dataDetail}
                busName={busSelected}
                date={keyword.fromDate}
                loadingDataDetail={loadingDataDetail}
            />

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                onConfirm={handleConfirmAlert}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

BusReport.propTypes = {}

export default BusReport;